import { MenuItem, Select, SxProps } from '@mui/material'
import { FC } from 'react'
import { portalLanguagesData } from 'app/appSettings'

interface Props {
  onChange: (lang: string) => void
  value: string
  sx?: SxProps
  disabled?: boolean
}

const SelectLanguageDropdownDumb: FC<Props> = ({ onChange, value, sx, disabled }) => {
  const handleLanguageChange = onChange

  return (
    <Select
      disabled={disabled}
      variant='outlined'
      value={value ?? 'en'}
      onChange={e => {
        handleLanguageChange(e.target.value)
      }}
      SelectDisplayProps={{
        id: 'language-change'
      }}
      sx={{
        maxWidth: 130,
        fontSize: 14,
        textAlign: 'left',
        '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
          padding: '8px 16px'
        },
        '& .MuiSelect-icon': {
          right: '12px'
        },
        ...sx
      }}
    >
      {Object.values(portalLanguagesData).map((obj, index) => {
        return (
          <MenuItem key={index} value={obj.editKey}>
            {obj.labelTrans}
          </MenuItem>
        )
      })}
    </Select>
  )
}

export default SelectLanguageDropdownDumb
